(function (SeoAccordion, $, undefined) {

  var bindUIActions = function () {  

    $(document).on('click', '.seo-toggle', function () {
      var accordionSpeed = 300;
      if ($('.seo-read-more').hasClass('active')) {
        $('.seo-read-more').removeClass('active');
        $('.seo-read-less').addClass('active');
        $('.seo-secondary').slideDown(accordionSpeed);
      } else {
        $('.seo-read-less').removeClass('active');
        $('.seo-read-more').addClass('active');
        $('.seo-secondary').slideUp(accordionSpeed);
      }
    });
  };

  SeoAccordion.init = function () {
    bindUIActions();
  };
 
}(window.SeoAccordion = window.SeoAccordion || {}, jQuery));
